import React, { useEffect } from "react";
import "./styles.css";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Footer from "./components/Footer/Footer";
import NavBar from "./components/NavBar/NavBar";
import Home from "./components/Home/Home";
import NotA404 from "./components/Assets/NotA404";
import QuienesSomos from "./components/QuienesSomos/QuienesSomos";
import Productos from "./components/Productos/Productos";
import NuestraOperacion from "./components/NuestraOperacion/NuestraOperacion";
import Contacto from "./components/Contacto/Contacto";

import { useTranslation } from "react-i18next";
import "./i18n"; // configuración de idiomas

const App = () => {
  return (
    <div className="appContainer">
      <BrowserRouter basename="/">
        <Routes>
          {/* Español directo en / */}
          <Route path="/*" element={<LangWrapper lng="es" />} />

          {/* Inglés en /en */}
          <Route path="/en/*" element={<LangWrapper lng="en" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

// Wrapper que setea idioma según la URL
const LangWrapper = ({ lng }) => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  return (
    <>
      <header>
        <NavBar />
      </header>
      <main>
        <Routes>
          {lng === "es" ? (
            <>
              <Route path="/" element={<Home />} />
              <Route path="quienes-somos" element={<QuienesSomos />} />
              <Route path="productos" element={<Productos />} />
              <Route path="nuestra-operacion" element={<NuestraOperacion />} />
              <Route path="contacto" element={<Contacto />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="about" element={<QuienesSomos />} />
              <Route path="products" element={<Productos />} />
              <Route path="operation" element={<NuestraOperacion />} />
              <Route path="contact" element={<Contacto />} />
            </>
          )}
          <Route path="*" element={<NotA404 />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
};

export default App;
